export enum EmailPanelForms {
  LanguageCustomizationPageForm = 'EmailCsatLanguageCustomizationPageForm',
  GlobalSettingsForm = 'EmailCsatGlobalSettingsForm',
}
